<div class="header actionBar">
    <div class="container-fluid">
          <div class="row">
          <i class="col-2 col-md-1 col-lg-1 icon" style="text-align:left;font-style:normal;" >&lt;</i>
          <i class="col-7 col-md-9 col-lg-9 heading1 icon" style="text-align:center;font-style:normal;">{{'myWallet'|translate}}</i>
          <i class="col-1 col-md-1 col-lg-1 fa fa-refresh icon" style="text-align:right;padding-top:8px;"></i>
          <i class="col-2 col-md-1 col-lg-1 fa fa-home icon" style="text-align:right;padding-top:8px"></i>
          </div>
    </div>
</div>